import type { FieldValues, FormProviderProps, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { FormProvider, useForm } from 'react-hook-form';
import { cn } from '@workspace/utils';

export interface FormProps<T extends FieldValues> extends FormProviderProps<T> {
    onSubmit: SubmitHandler<any>;
    className?: string;
}

export function SmartForm({ children, onSubmit, className, ...methods }: FormProps<any>) {
    return (
        <FormProvider {...methods}>
            <form autoComplete="off" className={cn('flex flex-col items-center', className)} onSubmit={methods.handleSubmit(onSubmit)}>
                {children}
            </form>
        </FormProvider>
    );
}

export function useSmartForm<T extends FieldValues>(): UseFormReturn<T> {
    return useForm<T>({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        shouldFocusError: true,
    });
}
